import { render, staticRenderFns } from "./TagsComboBox.vue?vue&type=template&id=3510474d&scoped=true&"
import script from "./TagsComboBox.vue?vue&type=script&lang=ts&"
export * from "./TagsComboBox.vue?vue&type=script&lang=ts&"
import style0 from "./TagsComboBox.vue?vue&type=style&index=0&id=3510474d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510474d",
  null
  
)

export default component.exports